import type { InjectionKey, Ref } from 'vue'
import type { PortCallTypeRef } from '../PortCallTypeRef'

export interface AddPortCallTypePayload {
  name: string
}

export type UpdatePortCallTypePayload = Partial<AddPortCallTypePayload>

export interface PortCallTypesService {
  /** All port call types, sorted by name. */
  portCallTypes: Ref<PortCallTypeRef[]>
  isLoading: { portCallTypes: boolean }
  /** Fetch the registry. No-op after first success unless `forceFetch`. */
  fetch(params?: { forceFetch?: boolean }): Promise<PortCallTypeRef[]>
  add(payload: AddPortCallTypePayload): Promise<PortCallTypeRef>
  update(
    id: string,
    payload: UpdatePortCallTypePayload
  ): Promise<PortCallTypeRef>
  remove(id: string): Promise<void>
}

export const portCallTypesKey = Symbol(
  'gs-portcall-types'
) as InjectionKey<PortCallTypesService>
